module.exports = __webpack_public_path__ + "img/微信图片_20251029163311_22_62.9cb11f8e.jpg";